import { AccountLayout } from '@bz/account';

export const route = {
  info: {
    login: true,
  },
} satisfies RouteDefinition;

export default AccountLayout;
